import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Alert } from "antd";
import { fetchUserNames } from "../../apis/usersApi";
import { saveUsedAgreement } from "../../apis/agreementsApi";
import { useLoading } from "../../components/LoadingContext";

const UsedAgreement = () => {
  const { slug } = useParams();
  const { user_id } = useParams();
  const [user, setUser] = useState(null);
  const [error, setError] = useState(null);
  const { setLoading } = useLoading();

  useEffect(() => {
    const save = async () => {
      try {
        setLoading(true);
        await saveUsedAgreement(slug, user_id);
        const response = await fetchUserNames(user_id);
        setUser(response);
        setLoading(false);
      } catch (err) {
        setError("No se pudo guardar el acuerdo usado.");
        setLoading(false);
      }
    };
    save();
  }, [slug, user_id]);

  if (error) {
    return (
      <div style={{ textAlign: "center", marginTop: 40 }}>
        <Alert message={error} type="error" showIcon />
      </div>
    );
  }

  if (!user) return null;

  return (
    <div style={{ maxWidth: 500, margin: "40px auto", textAlign: "center" }}>
      <h2>¡Ha llegado {user.name} {user.surname_1}!</h2>
      <p>
        Esta Girly es muy especial para nosotros, trátala igual de especial, para seguir fortaleciendo nuestros convenios.
      </p>
    </div>
  );
};

export default UsedAgreement;